import React, { memo } from 'react';
import { Control } from 'react-hook-form';
import { Box, Grid, GridSize, makeStyles } from '@material-ui/core';
import { EvaluationTab } from '../../types/Evaluation';
import { getFieldKey } from '../../services/evaluation-helpers';
import FieldRenderer from './FieldRenderer';
import { COLOR_MIDDLE_GRAY } from '../../styles/colors';

interface TabsRendererProps {
  tab: EvaluationTab;
  tabIndex: number;
  control: Control<any>;
}

const useStyles = makeStyles(theme => ({
  fieldSection: {
    padding: theme.spacing(2),
  },
  fieldRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    width: '100%',
  },
  fieldLabel: {
    width: 160,
    fontSize: theme.typography.pxToRem(12),
    color: COLOR_MIDDLE_GRAY,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: theme.spacing(0.5),
    },
  },
}), { name: 'TabsRenderer' });

/**
 * Renders all fields for a single tab from the evaluation schema.
 * Each field is rendered using the FieldRenderer component.
 */
function TabsRenderer({ tab, tabIndex, control }: TabsRendererProps) {
  const classes = useStyles();

  return (
    <Box className={classes.fieldSection}>
        <Grid container spacing={2}>
            {tab.fields.map((field, fieldIdx) => (
                <Grid key={field.name} item md={field?.grid as GridSize || 12}>
                    <Box className={classes.fieldRow}>
                    <FieldRenderer
                        name={getFieldKey(tabIndex, fieldIdx)}
                        label={field.name}
                        type={field.type}
                        control={control}
                        selectionMessage={field.selectionMessage}
                        options={field.options}
                    />
                    </Box>
                </Grid>
            ))}
            
        </Grid>
      {/* {tab.fields.map((field, fieldIdx) => (
        <Box key={field.name} className={classes.fieldRow}>
          <FieldRenderer
            name={getFieldKey(tabIndex, fieldIdx)}
            label={field.name}
            type={field.type}
            control={control}
            selectionMessage={field.selectionMessage}
            options={field.options}
          />
        </Box>
      ))} */}
    </Box>
  );
}

export default memo(TabsRenderer);
